"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotiTabs = exports.NotiTabType = void 0;
const phaser_1 = __importDefault(require("phaser"));
const EventConst_1 = require("../../constants/EventConst");
const TextureKeys_1 = require("../../constants/TextureKeys");
const Utils_1 = require("../../utils/Utils");
var NotiTabType;
(function (NotiTabType) {
    NotiTabType["All"] = "all";
    NotiTabType["Update"] = "update";
    NotiTabType["Other"] = "other";
})(NotiTabType = exports.NotiTabType || (exports.NotiTabType = {}));
class NotiTabs extends phaser_1.default.GameObjects.Container {
    constructor(scene) {
        super(scene);
        this.currentTab = NotiTabType.All;
        this.renderTabButtons();
    }
    renderTabButtons() {
        const scale = Utils_1.Utils.scale;
        const posY = 208 * scale;
        this.allTypeButton = this.scene.add
            .image(60 * scale, posY, TextureKeys_1.TextureKeys.InformationUI, 'all_btn_selected')
            .setScale(scale)
            .setOrigin(0)
            .setInteractive({ cursor: 'pointer' });
        this.add(this.allTypeButton);
        this.allTypeButton.on('pointerdown', () => {
            this.showAllType();
            this.emitTypeChanged(NotiTabType.All);
        });
        this.updateTypeButton = this.scene.add
            .image(275 * scale, posY, TextureKeys_1.TextureKeys.InformationUI, 'update_btn')
            .setScale(scale)
            .setOrigin(0)
            .setInteractive({ cursor: 'pointer' });
        this.add(this.updateTypeButton);
        this.updateTypeButton.on('pointerdown', () => {
            this.showUpdateType();
            this.emitTypeChanged(NotiTabType.Update);
        });
        this.otherTypeButton = this.scene.add
            .image(490 * scale, posY, TextureKeys_1.TextureKeys.InformationUI, 'other_btn')
            .setScale(scale)
            .setOrigin(0)
            .setInteractive({ cursor: 'pointer' });
        this.add(this.otherTypeButton);
        this.otherTypeButton.on('pointerdown', () => {
            this.showOtherType();
            this.emitTypeChanged(NotiTabType.Other);
        });
    }
    showAllType() {
        this.currentTab = NotiTabType.All;
        // active all type button
        this.allTypeButton.setFrame('all_btn_selected');
        // change other buttons
        this.updateTypeButton.setFrame('update_btn');
        this.otherTypeButton.setFrame('other_btn');
    }
    showUpdateType() {
        this.currentTab = NotiTabType.Update;
        // active all type button
        this.updateTypeButton.setFrame('update_btn_selected');
        // change other buttons
        this.allTypeButton.setFrame('all_btn');
        this.otherTypeButton.setFrame('other_btn');
    }
    showOtherType() {
        this.currentTab = NotiTabType.Other;
        // active all type button
        this.otherTypeButton.setFrame('other_btn_selected');
        // change other buttons
        this.updateTypeButton.setFrame('update_btn');
        this.allTypeButton.setFrame('all_btn');
    }
    emitTypeChanged(type) {
        this.scene.events.emit(EventConst_1.Events.NotiTabChange, type);
    }
    activeTab(type) {
        switch (type) {
            case NotiTabType.All: {
                this.showAllType();
                break;
            }
            case NotiTabType.Update: {
                this.showUpdateType();
                break;
            }
            case NotiTabType.Other: {
                this.showOtherType();
                break;
            }
        }
    }
}
exports.NotiTabs = NotiTabs;
